<!-- Backdrop -->
<div class="modal-backdrop" (click)="onBackdropClick($event)">
  <div class="modal" [class.modal--ea]="isEarlyAccess()" role="dialog" aria-modal="true" [attr.aria-label]="product().name">

    <!-- Close button -->
    <button class="modal__close" (click)="onClose()" aria-label="Cerrar">
      <app-icon [icon]="closeIcon" [size]="20" />
    </button>

    <!-- Two-column layout -->
    <div class="modal__body">

      <!-- Left: Image -->
      <div class="modal__image-wrap" [attr.data-variant]="product().variant">
        @if (hasBackImage()) {
          <div
            class="modal__flip-container"
            [class.modal__flip-container--flipped]="isFlipped()"
            role="button"
            tabindex="0"
            [attr.aria-label]="'Voltear ' + product().name"
            (click)="toggleFlip()"
            (keydown.enter)="toggleFlip(); $event.preventDefault()"
            (keydown.space)="toggleFlip(); $event.preventDefault()"
          >
            <img
              class="modal__image modal__face modal__face--front"
              [src]="product().imageUrl"
              [alt]="product().name"
            />
            <img
              class="modal__image modal__face modal__face--back"
              [src]="product().backImageUrl!"
              [alt]="product().name + ' — reverso'"
            />
          </div>
          <button
            class="modal__flip-btn"
            type="button"
            (click)="toggleFlip(); $event.stopPropagation()"
            aria-label="Voltear carta"
          >
            <app-icon [icon]="rotateIcon" [size]="16" />
            <span>Voltear</span>
          </button>
        } @else {
          <img class="modal__image" [src]="product().imageUrl" [alt]="product().name" />
        }
      </div>

      <!-- Right: Product info -->
      <div class="modal__info">

        <!-- HEADER: badges + name -->
        <div class="modal__header">
          <div class="modal__badges">
            @if (product().isNew) {
              <app-badge variant="new">Novedad</app-badge>
            }
            @if (isOutOfStock()) {
              <app-badge variant="sold-out">Agotado</app-badge>
            }
            <!-- Slot PROPIO del badge VIP (R3): coexiste con «Pre-venta». -->
            @if (isEarlyAccess()) {
              <app-badge variant="vip">{{ eaBadgeText() }}</app-badge>
            }
            @if (product().isPreSale) {
              <app-badge variant="pre-sale">Pre-venta</app-badge>
            }
          </div>
          <h2 class="modal__name">{{ product().name }}</h2>
        </div>

        <hr class="modal__divider" />

        <!-- PRICE SECTION (oculto en agotados — el back no envía precio) -->
        @if (!isOutOfStock()) {
        <div class="modal__price-section">
          <div class="modal__price-row">
            <span class="modal__price">{{ formattedPrice() }}</span>
            @if (product().isOnSale && discountPercent() > 0) {
              <app-badge variant="sale">-{{ discountPercent() }}%</app-badge>
            }
          </div>
          @if (product().isOnSale && product().originalPrice != null) {
            <span class="modal__original-price">{{ formattedOriginalPrice() }}</span>
          }
        </div>

        <hr class="modal__divider" />
        }

        <!-- META SECTION: solo para single cards -->
        @if (isSingle()) {
        <div class="modal__meta-section">

          <!-- Set + variant badge en la misma fila -->
          <div class="modal__set-row">
            @if (setLink(); as link) {
              <a
                class="modal__set modal__set--link"
                [routerLink]="link"
                (click)="onClose()"
              >{{ product().setName }}@if (product().setCode) { · {{ product().setCode }}}</a>
            } @else {
              <span class="modal__set">{{ product().setName }}@if (product().setCode) { · {{ product().setCode }}}</span>
            }
            <app-variant-badge [variant]="product().variant">
              {{ variantLabel() }}
            </app-variant-badge>
          </div>

          <!-- Stats: flex-wrap 33% — label arriba, valor truncado abajo -->
          <div class="modal__stats-list">
            @if (product().rarity) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">Rareza</span>
                <span class="modal__stat-value">{{ product().rarity }}</span>
              </div>
            }
            @if (product().cardType) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">Tipo</span>
                <span class="modal__stat-value">{{ product().cardType }}</span>
              </div>
            }
            @if (product().hp) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">HP</span>
                <span class="modal__stat-value">{{ product().hp }}</span>
              </div>
            }
            @if (product().stage) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">Etapa</span>
                <span class="modal__stat-value">{{ product().stage }}</span>
              </div>
            }
            @if (conditionTone(); as tone) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">Estado</span>
                <app-badge [variant]="tone">{{ conditionLabel() }}</app-badge>
              </div>
            }
            @if (formattedLanguage(); as language) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">Idioma</span>
                <span class="modal__stat-value">{{ language }}</span>
              </div>
            }
            <!-- Mecánicas de juego OP/MTG. Cada item se monta sólo si tiene
                 valor (productos legacy / Pokémon caen al else por defecto). -->
            @if (product().color) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">Color</span>
                <span class="modal__color-chip" [attr.data-color]="colorChipKey()">
                  <span class="modal__color-dot" aria-hidden="true"></span>
                  <span class="modal__stat-value">{{ product().color }}</span>
                </span>
              </div>
            }
            @if (product().cost) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">Coste</span>
                <span class="modal__stat-value modal__stat-value--tabular">{{ product().cost }}</span>
              </div>
            }
            @if (product().mana_cost) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">Maná</span>
                <span class="modal__stat-value modal__stat-value--mono">{{ product().mana_cost }}</span>
              </div>
            }
            @if (powerToughness(); as pt) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">{{ powerToughnessLabel() }}</span>
                <span class="modal__stat-value modal__stat-value--tabular">{{ pt }}</span>
              </div>
            }
            @if (product().counter) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">Counter</span>
                <span class="modal__stat-value modal__stat-value--tabular">{{ product().counter }}</span>
              </div>
            }
            @if (product().card_attribute) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">Atributo</span>
                <span class="modal__stat-value">{{ product().card_attribute }}</span>
              </div>
            }
            @if (subtypeChips().length) {
              <div class="modal__stat-item modal__stat-item--wide">
                <span class="modal__stat-label">Subtipo</span>
                <span class="modal__subtype-chips">
                  @for (chip of subtypeChips(); track chip) {
                    <span class="modal__subtype-chip">{{ chip }}</span>
                  }
                </span>
              </div>
            }
            @if (!isOutOfStock() && !isLowStock()) {
              <div class="modal__stat-item">
                <span class="modal__stat-label">Stock</span>
                <span class="modal__stat-value">{{ product().stock }}</span>
              </div>
            }
          </div>
        </div>
        } <!-- end @if single -->

        @if (hasShortDescription()) {
          <p class="modal__short-description">{{ product().shortDescription }}</p>
        } @else if (hasDescription()) {
          <p class="modal__short-description">
            {{ truncatedDescription() }}
            @if (descriptionNeedsTruncation()) {
              <button type="button" class="modal__read-more" (click)="onViewDetails()">
                Leer más
              </button>
            }
          </p>
        }

        @if (isLowStock()) {
          <span class="modal__low-stock">Últimas {{ product().stock }} unidades</span>
        }

        <hr class="modal__divider" />

        <!-- FOOTER: quantity + CTA + view details -->
        <div class="modal__footer">
          @if (!isOutOfStock()) {
            <div class="modal__add-row">
              <div class="modal__quantity-row">
                <span class="modal__qty-label">Cantidad:</span>
                <div class="modal__quantity">
                  <button
                    class="modal__qty-btn"
                    [disabled]="!canDecrement()"
                    (click)="decrement()"
                    aria-label="Reducir cantidad"
                  >
                    <app-icon [icon]="minusIcon" [size]="16" />
                  </button>
                  <span class="modal__qty-value">{{ quantity() }}</span>
                  <button
                    class="modal__qty-btn"
                    [disabled]="!canIncrement()"
                    (click)="increment()"
                    aria-label="Aumentar cantidad"
                  >
                    <app-icon [icon]="plusIcon" [size]="16" />
                  </button>
                </div>
              </div>

              <div class="modal__cta">
                @if (product().isPreSale) {
                  <app-button variant="primary" size="lg" (click)="onReserve()">
                    <span class="modal__btn-content">
                      <app-icon [icon]="calendarIcon" [size]="16" />
                      <span>Reservar</span>
                    </span>
                  </app-button>
                } @else {
                  <app-button variant="primary" size="lg" (click)="onAddToCart()">
                    <span class="modal__btn-content">
                      <app-icon [icon]="cartIcon" [size]="16" />
                      <span>Agregar al carrito</span>
                    </span>
                  </app-button>
                }
              </div>
            </div>
          } @else if (!product().isPreSale) {
            <!-- Dos estados, igual que la card: si no, la tarjeta dice "Ya no
                 me avises" y el quickview del mismo producto dice lo contrario. -->
            <div class="modal__cta modal__cta--full">
              @if (notifyActive()) {
                <app-button variant="ghost" size="lg" (click)="onNotifyCancel()">
                  <span class="modal__btn-content">
                    <app-icon [icon]="bellOffIcon" [size]="16" />
                    <span>Ya no me avises</span>
                  </span>
                </app-button>
              } @else {
                <app-button variant="ghost" size="lg" (click)="onNotify()">
                  <span class="modal__btn-content">
                    <app-icon [icon]="bellIcon" [size]="16" />
                    <span>Avisarme cuando esté disponible</span>
                  </span>
                </app-button>
              }
            </div>
          } @else {
            <!-- Pre-sale sin cupos: CTA atenuado con tooltip y toast informativo. -->
            <div class="modal__cta modal__cta--full">
              <app-button
                variant="primary"
                size="lg"
                class="btn-sold-out"
                [appTooltip]="prepurchaseSoldOutMessage"
                (click)="onPrepurchaseSoldOutClick()"
              >
                <span class="modal__btn-content">
                  <app-icon [icon]="calendarIcon" [size]="16" />
                  <span>Precompra Agotada</span>
                </span>
              </app-button>
            </div>
          }

          <!-- Corazón de la lista de deseos (B29, autocontenido): a la derecha de la acción principal. -->
          <app-wishlist-button class="modal__wishlist-btn" [productId]="product().id" [iconSize]="18" />

          <button class="modal__view-details" (click)="onViewDetails()">
            Ver ficha completa
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
